<h5 class="zint-card-title max-width-85">{{ label }}</h5>
@if(!value) {
<div class="aira-nodata-icon-backdrop">
    <i class="fa-duotone fa-thin fa-gauge-simple-high"></i>
    <p>No insights have been derived.</p>
</div>
}
@else {    
    <gauge [gaugeData]="{value, maximumValue}" [ngClass]="{'blur-content-strong': previewOnly}"></gauge>
}
